var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,10.06104c0,-5.55664 -4.47717,-10.06104 -10,-10.06104c-5.52283,0 -10,4.50439 -10,10.06104c0,5.02197 3.65686,9.18408 8.4375,9.93896v-7.03052v0h-2.53906v0v-2.90845v0h2.53906v0v-2.21655c0,-2.52148 1.49292,-3.91431 3.77716,-3.91431c1.09406,0 2.23846,0.19653 2.23846,0.19653v0v2.47583v0h-1.26099c-1.24225,0 -1.62964,0.77563 -1.62964,1.57129v1.88721v0h2.77344v0l-0.44336,2.90845v0h-2.33008v0v7.03052c4.78064,-0.75488 8.4375,-4.91699 8.4375,-9.93896",
    fill: "currentColor"
  })));
};
export default SvgFacebook;